import React from 'react'

export class ReportAlert extends React.Component {
    constructor() {
        super()
        this.state = {
            hideBanner: window && window.localStorage ? Boolean(window.localStorage.getItem('hideBanner2024')) : true
        }
    }

    interactWithBanner = () => {
        this.setState({ hideBanner: true })
        if (window && window.localStorage) {
            window.localStorage.setItem('hideBanner2024', true)
        }
    }

    render () {
        if (this.state.hideBanner) {
            return null
        }
        return (
            <div className="header__container container report-alert">
                <span className="report-title">
                    The State of Translation Automation 2025 report is out now!
                </span>
                <div className="elementor-icon-list-item elementor-inline-item" >
                    <a href="https://inten.to/machine-translation-report-2024/" onClick={() => this.interactWithBanner()} target="_blank" rel="noopener noreferrer">
                        <span className="elementor-icon-list-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                                <path d="M1 7.28516L17 7.28516" stroke="#2143F3" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.714 1L16.9997 7.28571L10.714 13.5714" stroke="#2143F3" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>					
                        </span>
                        <span className="elementor-icon-list-text"><b>Get your copy</b></span>
                    </a>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className="report-cross" onClick={() => this.interactWithBanner()}>
                    <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
                </svg>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Header/ReportAlert.jsx